import React from 'react';
import styled from 'styled-components';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../../CommonComponents/OPL/Shimmer/Shimmer';

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 32,
  padding: '16px 24px',
  borderTop: `1px solid ${theme.colors.neutral['200']}`,

  '&:first-of-type': {
    borderTop: 'none',
  },
}));

export const ClientLoading = () => {
  return (
    <Wrapper>
      <Box flex={1}>
        <Shimmer width="100%" height={24} mb="4" />
        <Shimmer width="75%" height={16} />
      </Box>

      <Shimmer width={68} height={21} />
    </Wrapper>
  );
};
